module.exports = __webpack_public_path__ + "88d5db64a06d056cfb7db28b308414cc.svg";